// extracted by mini-css-extract-plugin
export default {"previousButton":"ButtonGroup_previousButton__uad5R","nextButton":"ButtonGroup_nextButton__KA-KT","progressBarWrapper":"ButtonGroup_progressBarWrapper__Y5ZA1"};